import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common
import { LoadScreen } from "../../common/LoadScreen";
import { api } from "../../common/ApiPromisify";
//ClientLibsReference
import { Belfastpilatesappspotcom } from "../../common/ClientLibsReference";
import { logout } from "../../common/helpers/auth";

export class Classes extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      loaded2: false,
      serviceList: [],
      serviceSelected: false,
      selectedService: "",
      selectedServiceId: "",
      selectedServiceTitle: "",
      selectedServiceDetails: "",
      selectedServicePrice: "",
      selectedServiceCurrency: "GBP",
      selectedServiceDifficultyLevel: "",
      selectedServiceLastUpdatedDateTime: "",
      serviceEdited: false,
      editedService: "",
      editedServiceId: "",
      editedServiceTitle: "",
      editedServiceDetails: "",
      editedServicePrice: "",
      editedServiceDifficultyLevel: "",
      editedServiceLastUpdatedDateTime: "",
      viewingSets: false,
      viewingClasses: false,
      setList: [],
      setSelected: false,
      selectedSet: "",
      selectedSetDateFrom: "",
      selectedSetDateTo: "",
      selectedSetMaxNumberOfParticipants: "",
      selectedSetNumberOfParticipants: "",
      selectedSetInstructors: "",
      selectedSetInstructorNames: "",
      selectedSetBookList: "",
      selectedSetBookedUserDetails: [],
      selectedSetCompleteBookedListUserDetails: [],
      selectedSetId: "",
      selectedSetLastUpdatedDateTime: "",
      setEdited: false,
      editedSet: "",
      editedSetDateFrom: "",
      editedSetDateTo: "",
      editedSetMaxNumberOfParticipants: "",
      editedSetNumberOfParticipants: "",
      editedSetInstructors: "",
      editedSetInstructorNames: "",
      editedSetBookList: "",
      editedSetBookedUserDetails: [],
      instructorList: [],
      clientList: [],
      clientOptions: [],
      selectedClient: "",
      pickListAvailable: [],
      pickListSelected: [],
      selectedPaid: false,
      selectedPaymentMethod: "",
      hide: true,
    };
  }

  componentDidMount = () => {
    if (localStorage.getItem("roleType") === "30") {
      logout();
      localStorage.clear();
      window.location = "#/";
      window.location.reload();
    }
    this.getClients();
    this.getInstructors();
    this.getServices();
  };

  getClients = async () => {
    let userRequest = new Belfastpilatesappspotcom.UserRequest();
    userRequest.codeTag = localStorage.getItem("globalBid");
    userRequest.roleType = 30;

    await api("userApiV1UserListByRoleType", userRequest).then((res) => {
      if (res.data) {
        if (Array.isArray(res.data.users)) {
          res.data.users.forEach((e) => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
          });
        }

        let userResponse =
          Belfastpilatesappspotcom.UserResponse.constructFromObject(res.data);
        console.log(userResponse);

        if (userResponse.errorCode === 0) {
          this.setState({
            clientList: userResponse.users,
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Clients could not be retrieved, please refresh and try again",
            life: 3000,
          });
        }
      } else {
        console.log("userApiV1UserListByRoleType has failed");
      }
    });
  };

  clientsToOptions = () => {
    let clientArray = [];

    if (Array.isArray(this.state.clientList)) {
      this.state.clientList.forEach((e) => {
        if (e.level === this.state.selectedServiceDifficultyLevel) {
          clientArray.push({
            label: e.firstName + " " + e.surname,
            value: e.id,
          });
        }
      });
    }

    this.setState({ clientOptions: clientArray });
  };

  getInstructors = async () => {
    let userRequest = new Belfastpilatesappspotcom.UserRequest();
    userRequest.codeTag = localStorage.getItem("globalBid");

    await api("userApiV1UserListInBusiness", userRequest).then((res) => {
      if (res.data) {
        if (res.data.lastUpdatedDateTime) {
          res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
        }

        let userResponse =
          Belfastpilatesappspotcom.UserResponse.constructFromObject(res.data);
        console.log(userResponse);

        if (userResponse.errorCode === 0) {
          this.setState({
            instructorList: userResponse.users,
            pickListAvailable: userResponse.users,
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Instructors could not be retrieved, please refresh and try again",
            life: 3000,
          });
        }
      } else {
        console.log("userApiV1UserListInBusiness has failed");
      }
    });
  };

  getServices = async () => {
    this.setState({ loaded: false });

    let serviceRequest = new Belfastpilatesappspotcom.ServiceRequest();
    serviceRequest.codeTag = localStorage.getItem("globalBid");

    await api("serviceApiV1ServiceGetByCodeTag", serviceRequest).then((res) => {
      if (res.data) {
        if (Array.isArray(res.data.serviceList)) {
          res.data.serviceList.forEach((e) => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
          });
        }

        let serviceResponse =
          Belfastpilatesappspotcom.ServiceResponse.constructFromObject(
            res.data
          );
        console.log(serviceResponse);

        if (serviceResponse.errorCode === 0) {
          this.setState({
            serviceList: serviceResponse.serviceList,
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Levels could not be retrieved, please refresh and try again",
            life: 3000,
          });
        }
      } else {
        console.log("serviceApiV1ServiceGetByCodeTag has failed");
      }
    });

    this.setState({ loaded: true });
  };

  updateService = async () => {
    this.setState({ loaded: false });

    let serviceRequest = new Belfastpilatesappspotcom.ServiceRequest();
    serviceRequest.codeTag = localStorage.getItem("globalBid");
    serviceRequest.userId = localStorage.getItem("userId");
    serviceRequest.id = this.state.editedServiceId;
    serviceRequest.lastUpdatedDateTime =
      this.state.editedServiceLastUpdatedDateTime;
    serviceRequest.description = this.state.editedServiceDetails;
    serviceRequest.cost = this.state.editedServicePrice * 100;

    await api("serviceApiV1ServiceUpdate", serviceRequest).then((res) => {
      if (res.data) {
        let serviceResponse =
          Belfastpilatesappspotcom.ServiceResponse.constructFromObject(
            res.data
          );
        console.log(serviceResponse);

        if (serviceResponse.errorCode === 0) {
          this.getServices();
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Level could not be updated, please try again",
            life: 3000,
          });
        }
      } else {
        console.log("serviceApiV1ServiceUpdate has failed");
      }
    });
  };

  getServiceAdvanced = async () => {
    if (Array.isArray(this.state.serviceList)) {
      this.state.serviceList.forEach((e) => {
        if (e.level === "Intermediate/Advanced") {
          console.log(e);
          this.setState(
            {
              viewingSets: false,
              viewingClasses: false,
              serviceEdited: false,
              serviceSelected: true,
              selectedService: e,
              selectedServiceId: e.id,
              selectedServiceTitle: e.name,
              selectedServiceDetails: e.description,
              selectedServicePrice: e.cost,
              selectedServiceDifficultyLevel: e.level,
              selectedServiceLastUpdatedDateTime: e.lastUpdatedDateTime,
            },
            () => {
              this.clientsToOptions();
            }
          );
        }
      });
    }
  };

  getServiceIntermediate = async () => {
    if (Array.isArray(this.state.serviceList)) {
      this.state.serviceList.forEach((e) => {
        if (e.level === "Progressive/Intermediate") {
          console.log(e);
          this.setState(
            {
              viewingSets: false,
              viewingClasses: false,
              serviceEdited: false,
              serviceSelected: true,
              selectedService: e,
              selectedServiceId: e.id,
              selectedServiceTitle: e.name,
              selectedServiceDetails: e.description,
              selectedServicePrice: e.cost,
              selectedServiceDifficultyLevel: e.level,
              selectedServiceLastUpdatedDateTime: e.lastUpdatedDateTime,
            },
            () => {
              this.clientsToOptions();
            }
          );
        }
      });
    }
  };

  getServiceBeginner = async () => {
    if (Array.isArray(this.state.serviceList)) {
      this.state.serviceList.forEach((e) => {
        if (e.level === "Beginner/Progressive") {
          console.log(e);
          this.setState(
            {
              viewingSets: false,
              viewingClasses: false,
              serviceEdited: false,
              serviceSelected: true,
              selectedService: e,
              selectedServiceId: e.id,
              selectedServiceTitle: e.name,
              selectedServiceDetails: e.description,
              selectedServicePrice: e.cost,
              selectedServiceDifficultyLevel: e.level,
              selectedServiceLastUpdatedDateTime: e.lastUpdatedDateTime,
            },
            () => {
              this.clientsToOptions();
            }
          );
        }
      });
    }
  };

  getServiceReformer = async () => {
    if (Array.isArray(this.state.serviceList)) {
      this.state.serviceList.forEach((e) => {
        if (e.level === "Reformer") {
          console.log(e);
          this.setState(
            {
              viewingSets: false,
              viewingClasses: false,
              serviceEdited: false,
              serviceSelected: true,
              selectedService: e,
              selectedServiceId: e.id,
              selectedServiceTitle: e.name,
              selectedServiceDetails: e.description,
              selectedServicePrice: e.cost,
              selectedServiceDifficultyLevel: e.level,
              selectedServiceLastUpdatedDateTime: e.lastUpdatedDateTime,
            },
            () => {
              this.clientsToOptions();
            }
          );
        }
      });
    }
  };

  getServiceMumAndBaby = async () => {
    if (Array.isArray(this.state.serviceList)) {
      this.state.serviceList.forEach((e) => {
        if (e.level === "Mum and Baby") {
          console.log(e);
          this.setState(
            {
              viewingSets: false,
              viewingClasses: false,
              serviceEdited: false,
              serviceSelected: true,
              selectedService: e,
              selectedServiceId: e.id,
              selectedServiceTitle: e.name,
              selectedServiceDetails: e.description,
              selectedServicePrice: e.cost,
              selectedServiceDifficultyLevel: e.level,
              selectedServiceLastUpdatedDateTime: e.lastUpdatedDateTime,
            },
            () => {
              this.clientsToOptions();
            }
          );
        }
      });
    }
  };

  getServiceAntenatal = async () => {
    if (Array.isArray(this.state.serviceList)) {
      this.state.serviceList.forEach((e) => {
        if (e.level === "Antenatal") {
          console.log(e);
          this.setState(
            {
              viewingSets: false,
              viewingClasses: false,
              serviceEdited: false,
              serviceSelected: true,
              selectedService: e,
              selectedServiceId: e.id,
              selectedServiceTitle: e.name,
              selectedServiceDetails: e.description,
              selectedServicePrice: e.cost,
              selectedServiceDifficultyLevel: e.level,
              selectedServiceLastUpdatedDateTime: e.lastUpdatedDateTime,
            },
            () => {
              this.clientsToOptions();
            }
          );
        }
      });
    }
  };

  getServiceKids = async () => {
    if (Array.isArray(this.state.serviceList)) {
      this.state.serviceList.forEach((e) => {
        if (e.level === "Kids") {
          console.log(e);
          this.setState(
            {
              viewingSets: false,
              viewingClasses: false,
              serviceEdited: false,
              serviceSelected: true,
              selectedService: e,
              selectedServiceId: e.id,
              selectedServiceTitle: e.name,
              selectedServiceDetails: e.description,
              selectedServicePrice: e.cost,
              selectedServiceDifficultyLevel: e.level,
              selectedServiceLastUpdatedDateTime: e.lastUpdatedDateTime,
            },
            () => {
              this.clientsToOptions();
            }
          );
        }
      });
    }
  };

  getServiceMatureMovers = async () => {
    if (Array.isArray(this.state.serviceList)) {
      this.state.serviceList.forEach((e) => {
        if (e.level === "Mature Movers") {
          console.log(e);
          this.setState(
            {
              viewingSets: false,
              viewingClasses: false,
              serviceEdited: false,
              serviceSelected: true,
              selectedService: e,
              selectedServiceId: e.id,
              selectedServiceTitle: e.name,
              selectedServiceDetails: e.description,
              selectedServicePrice: e.cost,
              selectedServiceDifficultyLevel: e.level,
              selectedServiceLastUpdatedDateTime: e.lastUpdatedDateTime,
            },
            () => {
              this.clientsToOptions();
            }
          );
        }
      });
    }
  };

  getServiceSets = async () => {
    this.setState({ loaded2: false });

    let setRequest = new Belfastpilatesappspotcom.SetRequest();
    setRequest.codeTag = localStorage.getItem("globalBid");
    setRequest.bookIdentifier = "CREATE";
    setRequest.serviceId = this.state.selectedServiceId;

    await api("setApiV1SetGetByServiceId", setRequest).then((res) => {
      if (res.data) {
        if (Array.isArray(res.data.setList)) {
          res.data.setList.forEach((e) => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
            if (e.startDate) {
              e.startDate = e.startDate.toJSON();
            }
            if (e.endDate) {
              e.endDate = e.endDate.toJSON();
            }
          });
        }

        let setResponse =
          Belfastpilatesappspotcom.SetResponse.constructFromObject(res.data);
        console.log(setResponse);

        if (setResponse.errorCode === 0) {
          this.setState({
            setList: setResponse.setList,
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Sets could not be retrieved, please refresh and try again",
            life: 3000,
          });
        }
      } else {
        console.log("setApiV1SetGetByServiceId has failed");
      }
    });

    this.setState({ loaded2: true });
  };

  updateSet = async (ids) => {
    let idArray = [];

    let setRequest = new Belfastpilatesappspotcom.SetRequest();
    setRequest.codeTag = localStorage.getItem("globalBid");
    setRequest.userId = localStorage.getItem("userId");
    setRequest.id = this.state.selectedSetId;
    setRequest.lastUpdatedDateTime = this.state.selectedSetLastUpdatedDateTime;
    if (ids) {
      setRequest.instructorIds = ids;
    }
    if (Array.isArray(this.state.pickListSelected)) {
      this.state.pickListSelected.forEach((e) => {
        idArray.push(e.id);
      });
      setRequest.instructorIds = idArray;
    }

    await api("setApiV1SetUpdate", setRequest).then((res) => {
      if (res.data) {
        let setResponse =
          Belfastpilatesappspotcom.SetResponse.constructFromObject(res.data);
        console.log(setResponse);

        if (setResponse.errorCode === 0) {
          this.setState({ setEdited: false }, () => {
            this.getServiceSets();
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Set could not be updated, please try again",
            life: 3000,
          });
        }
      } else {
        console.log("setApiV1SetUpdate has failed");
      }
    });
  };

  updateClients = async () => {
    let bookRequest = new Belfastpilatesappspotcom.BookRequest();
    bookRequest.codeTag = localStorage.getItem("globalBid");
    bookRequest.employeeUserId = localStorage.getItem("userId");
    bookRequest.setId = this.state.selectedSetId;
    bookRequest.lastUpdatedDateTime = this.state.selectedSetLastUpdatedDateTime;
    bookRequest.userId = this.state.selectedClient;
    bookRequest.price = this.state.selectedServicePrice;
    bookRequest.currencyCode = this.state.selectedServiceCurrency;
    bookRequest.indentifier = "CREATE";
    bookRequest.paid = this.state.selectedPaid;
    bookRequest.paymentMethod = this.state.selectedPaymentMethod;

    await api("bookApiV1BookCreateBySet", bookRequest).then((res) => {
      if (res.data) {
        let bookResponse =
          Belfastpilatesappspotcom.BookResponse.constructFromObject(res.data);
        console.log(bookResponse);

        if (bookResponse.errorCode === 0) {
          this.setState({ setEdited: false }, () => {
            this.getServiceSets();
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Set could not be updated, please try again",
            life: 3000,
          });
        }
      } else {
        console.log("bookApiV1BookCreateBySet has failed");
      }
    });
  };

  setsToCard = () => {
    let setArray = [];
    let i = 0;
    let instructorNamesArray = [];
    let i2 = 0;
    let place = [
      <div key={i} className="ui-g-12">
        <div className="card">
          <h1>&nbsp;</h1>
          <h1>No Sets</h1>
          <h1>&nbsp;</h1>
        </div>
      </div>,
    ];

    if (Array.isArray(this.state.setList)) {
      this.state.setList.forEach((e) => {
        setArray[i] = (
          <div key={i} className="ui-g-12">
            <div
              id={i}
              className="card"
              onMouseOver={(f) => {
                f.currentTarget.style.boxShadow = "5px 5px 10px grey";
              }}
              onMouseOut={(f) => {
                f.currentTarget.style.boxShadow = "";
              }}
              onClick={(g) => {
                let element = document.getElementById(
                  localStorage.getItem("classesLastSelectedCardId")
                );
                if (element) {
                  element.style.backgroundColor = "white";
                }
                g.currentTarget.style.backgroundColor = "#F44336";
                localStorage.setItem(
                  "classesLastSelectedCardId",
                  g.currentTarget.id
                );

                if (Array.isArray(e.instructorDetails)) {
                  e.instructorDetails.forEach((f) => {
                    instructorNamesArray[i2] = (
                      <li key={i2}>{f.firstName + " " + f.surname}</li>
                    );
                    i2++;
                  });
                }
                this.setState(
                  {
                    setEdited: false,
                    setSelected: true,
                    selectedSet: e,
                    selectedSetDateFrom: e.startDateDisplayString,
                    selectedSetDateTo: e.endDateDisplayString,
                    selectedSetDateFrom2: e.startDate,
                    selectedSetDateTo2: e.endDate,
                    selectedSetMaxNumberOfParticipants: e.maxSpace,
                    selectedSetNumberOfParticipants: e.currentNumberOfUsers,
                    selectedSetInstructors: e.instructorDetails,
                    selectedSetInstructorNames: instructorNamesArray,
                    selectedSetBookList: e.bookList,
                    selectedSetBookedUserDetails: e.bookedUserDetails,
                    selectedSetCompleteBookedListUserDetails:
                      e.completeBookedListUserDetails,
                    selectedSetId: e.id,
                    selectedSetLastUpdatedDateTime: e.lastUpdatedDateTime,
                    pickListSelected: e.instructorDetails,
                  },
                  () => {
                    console.log(this.state.selectedSet);
                    if (Array.isArray(this.state.pickListSelected)) {
                      this.removePickListDuplicates();
                    }
                  }
                );
              }}
              style={{
                cursor: "pointer",
              }}
            >
              <h1>{e.startDateDisplayString}</h1>
              <h2>to</h2>
              <h1>{e.endDateDisplayString}</h1>
            </div>
          </div>
        );
        i++;
      });
    }

    if (!Array.isArray(setArray)) {
      return place;
    }
    return setArray;
  };

  removePickListDuplicates = () => {
    let i = 0;

    this.state.pickListAvailable.forEach((e) => {
      this.state.pickListSelected.forEach((f) => {
        if (e.id === f.id) {
          let pickListAvailable = this.state.pickListAvailable;
          pickListAvailable.splice(i, 1);
          this.setState({ pickListAvailable: pickListAvailable });
          i--;
        }
      });
      i++;
    });
  };

  booksToCard = () => {
    let bookArray = [];
    let i = 0;

    if (this.state.selectedSetBookList === undefined) {
      return;
    }
    this.state.selectedSetBookList.forEach((e) => {
      bookArray[i] = (
        <div
          key={i}
          id={i}
          className="card"
          onMouseOver={(f) => {
            f.currentTarget.style.boxShadow = "5px 5px 10px grey";
          }}
          onMouseOut={(f) => {
            f.currentTarget.style.boxShadow = "";
          }}
          onClick={() => {
            window.location = "/#/managesets";
          }}
          style={{
            cursor: "pointer",
          }}
        >
          <div className="ui-g" style={{ textAlign: "center" }}>
            <div className="ui-g-12 ui-md-4" style={{ textAlign: "left" }}>
              <br />
              <h1>{e.level}</h1>
            </div>
            <div className="ui-g-12 ui-md-3">
              <br />
              <h1>{e.dateToDisplay}</h1>
            </div>
            <div className="ui-g-12 ui-md-3">
              <br />
              <h1>
                {e.dayOfWeek === "1"
                  ? "Monday"
                  : e.dayOfWeek === "2"
                  ? "Tuesday"
                  : e.dayOfWeek === "3"
                  ? "Wednesday"
                  : e.dayOfWeek === "4"
                  ? "Thursday"
                  : e.dayOfWeek === "5"
                  ? "Friday"
                  : "Not Set"}
              </h1>
            </div>
            <div className="ui-g-12 ui-md-2">
              <h1>{e.startTime}</h1>
              <h1>to</h1>
              <h1>{e.endTime}</h1>
            </div>
          </div>
        </div>
      );
      i++;
    });

    return bookArray;
  };

  render() {
    if (!this.state.loaded) {
      return (
        <center>
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={(el) => (this.growl = el)}
          />
          <LoadScreen />
        </center>
      );
    }
    return (
      <div className="ui-g">
        <div className="ui-g-12">
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={(el) => (this.growl = el)}
          />
          <div className="ui-g-12 ui-md-2">
            <pr.Button
              className="red-btn"
              label="Intermediate/Advanced"
              onClick={() => {
                this.getServiceAdvanced();
              }}
              style={{ width: "100%" }}
            />
          </div>
          <div className="ui-g-12 ui-md-2">
            <pr.Button
              className="green-btn"
              label="Progressive/Intermediate"
              onClick={() => {
                this.getServiceIntermediate();
              }}
              style={{ width: "100%" }}
            />
          </div>
          <div className="ui-g-12 ui-md-2">
            <pr.Button
              className="indigo-btn"
              label="Beginner/Progressive"
              onClick={() => {
                this.getServiceBeginner();
              }}
              style={{ width: "100%" }}
            />
          </div>
          <div className="ui-g-12 ui-md-2">
            <pr.Button
              className="pink-btn"
              label="Reformer"
              onClick={() => {
                this.getServiceReformer();
              }}
              style={{ width: "100%" }}
            />
          </div>
          <div className="ui-g-12 ui-md-2">
            <pr.Button
              className="amber-btn"
              label="Mum and Baby"
              onClick={() => {
                this.getServiceMumAndBaby();
              }}
              style={{ color: "white", width: "100%" }}
            />
          </div>
          <div className="ui-g-12 ui-md-2">
            <pr.Button
              className="orange-btn"
              label="Antenatal"
              onClick={() => {
                this.getServiceAntenatal();
              }}
              style={{ width: "100%" }}
            />
          </div>
          <div className="ui-g-12 ui-md-2">
            <pr.Button
              className="cyan-btn"
              label="Kids"
              onClick={() => {
                this.getServiceKids();
              }}
              style={{ width: "100%" }}
            />
          </div>
          <div className="ui-g-12 ui-md-2">
            <pr.Button
              className="violet-btn"
              label="Mature Movers"
              onClick={() => {
                this.getServiceMatureMovers();
              }}
              style={{ width: "100%" }}
            />
          </div>
        </div>

        <div className="ui-g-12">
          {!this.state.serviceSelected ? (
            <label />
          ) : (
            <div className="card">
              <div className="ui-g">
                <div className="ui-g-12">
                  <pr.Button
                    className="secondary-btn"
                    icon="pi pi-pencil"
                    onClick={() => {
                      this.setState({
                        serviceSelected: false,
                        serviceEdited: true,
                        editedService: this.state.selectedService,
                        editedServiceId: this.state.selectedServiceId,
                        editedServiceTitle: this.state.selectedServiceTitle,
                        editedServiceDetails: this.state.selectedServiceDetails,
                        editedServicePrice:
                          this.state.selectedServicePrice / 100,
                        editedServiceDifficultyLevel:
                          this.state.selectedServiceDifficultyLevel,
                        editedServiceLastUpdatedDateTime:
                          this.state.selectedServiceLastUpdatedDateTime,
                      });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
                <div className="ui-g-12">
                  <h1>
                    <b>Class Title: </b>
                    {this.state.selectedServiceTitle}
                  </h1>
                </div>
                <div className="ui-g-12 ui-md-6 ui-g-nopad">
                  <div className="ui-g-12">
                    <b>Details:</b>
                    <br />
                    <textarea
                      rows="10"
                      readOnly={true}
                      value={this.state.selectedServiceDetails || "Not Set"}
                      style={{ width: "100%", resize: "none" }}
                    />
                  </div>
                </div>
                <div className="ui-g-12 ui-md-6">
                  <div className="ui-g-12">
                    <b>Price: </b>
                    <label>
                      {"£" +
                        this.state.selectedServicePrice / 100 +
                        " per class"}
                    </label>
                  </div>
                  <div className="ui-g-12">
                    <b>Difficulty Level: </b>
                    <label>{this.state.selectedServiceDifficultyLevel}</label>
                  </div>
                </div>
                {this.state.hide === true ? (
                  <label />
                ) : (
                  <div className="ui-g-12">
                    <pr.Button
                      label="View Sets"
                      onClick={() => {
                        this.getServiceSets();
                        this.setState({
                          setEdited: false,
                          setSelected: false,
                          viewingSets: true,
                        });
                      }}
                      style={{ float: "right" }}
                    />
                  </div>
                )}
              </div>
            </div>
          )}

          {this.state.serviceEdited === false ? (
            <label />
          ) : (
            <div className="card">
              <div className="ui-g">
                <div className="ui-g-12">
                  <pr.Button
                    className="secondary-btn"
                    icon="pi pi-times"
                    onClick={() => {
                      this.setState({
                        serviceEdited: false,
                        serviceSelected: true,
                      });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
                <div className="ui-g-12">
                  <h1>
                    <b>Class Title: </b>
                    {this.state.selectedServiceTitle}
                  </h1>
                </div>
                <div className="ui-g-12 ui-md-6 ui-g-nopad">
                  <div className="ui-g-12">
                    <label>Details:</label>
                    <br />
                    <textarea
                      rows="10"
                      value={this.state.editedServiceDetails}
                      onChange={(e) =>
                        this.setState({
                          editedServiceDetails: e.target.value,
                        })
                      }
                      style={{ width: "100%", resize: "none" }}
                    />
                  </div>
                </div>
                <div className="ui-g-12 ui-md-6">
                  <div className="ui-g-12">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedServicePrice === ""
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedServicePrice}
                        onChange={(e) =>
                          this.setState({
                            editedServicePrice: e.target.value,
                          })
                        }
                      />
                      <label>Price per Class</label>
                    </span>
                  </div>
                  <div className="ui-g-12">
                    <label>Difficulty Level: </label>
                    <label>{this.state.selectedServiceDifficultyLevel}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <pr.Button
                    label="Save"
                    onClick={() => {
                      this.updateService();
                      this.setState({
                        serviceEdited: false,
                        serviceSelected: false,
                      });
                    }}
                    style={{ float: "right" }}
                  />
                  <pr.Button
                    label="Cancel"
                    onClick={() => {
                      this.setState({
                        serviceEdited: false,
                        serviceSelected: true,
                      });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            </div>
          )}

          {!this.state.viewingSets ? (
            <label />
          ) : !this.state.loaded2 ? (
            <center>
              <pr.ProgressSpinner style={{ align: "middle" }} />
            </center>
          ) : (
            <div className="card">
              <div className="ui-g">
                <div
                  className="ui-g-12 ui-md-4"
                  style={{ textAlign: "center" }}
                >
                  {this.setsToCard()}
                </div>
                <div className="ui-g-12 ui-md-8">
                  <div className="ui-g-12">
                    <h1>Set Details</h1>
                  </div>
                  {!this.state.setSelected ? (
                    <label />
                  ) : (
                    <div>
                      <div className="ui-g-12 ui-md-6">
                        <div className="ui-g-12">
                          <b>Date From: </b>
                          <label>{this.state.selectedSetDateFrom}</label>
                        </div>
                        <div className="ui-g-12">
                          <b>Date To: </b>
                          <label>{this.state.selectedSetDateTo}</label>
                        </div>
                      </div>
                      <div className="ui-g-12 ui-md-6">
                        <div className="ui-g-12">
                          <b>Instructor(s): </b>
                          <ul>
                            {Array.isArray(
                              this.state.selectedSetInstructorNames
                            ) ? (
                              this.state.selectedSetInstructorNames
                            ) : (
                              <li>Not Set</li>
                            )}
                          </ul>
                        </div>
                      </div>
                      <div className="ui-g-12">
                        <label>
                          Slots{" "}
                          {!this.state.selectedSetBookedUserDetails
                            ? this.state.selectedSetMaxNumberOfParticipants || 0
                            : this.state.selectedSetMaxNumberOfParticipants -
                              this.state.selectedSetBookedUserDetails
                                .length}{" "}
                          of{" "}
                          {!this.state.selectedSetMaxNumberOfParticipants
                            ? 0
                            : this.state
                                .selectedSetMaxNumberOfParticipants}{" "}
                          remaining
                        </label>
                      </div>
                      <div className="ui-g-12">
                        <b>List of Clients in Set</b>
                        <br />
                        <pr.DataTable
                          value={
                            this.state.selectedSetCompleteBookedListUserDetails
                          }
                          selectionMode="single"
                          onSelectionChange={() => {}}
                          header="Clients"
                          autoLayout={true}
                          paginator={true}
                          alwaysShowPaginator={true}
                          rows="10"
                          emptyMessage="No clients in set"
                        >
                          <pr.Column
                            field="bookedUserDetails.firstName"
                            header="First Name"
                            body={(e) => {
                              if (
                                e.bookedUserDetails &&
                                e.bookedUserDetails.length
                              ) {
                                return e.bookedUserDetails[0].firstName;
                              }
                            }}
                            sortable={false}
                            filter={false}
                            style={{ overflow: "auto" }}
                          />
                          <pr.Column
                            field="bookedUserDetails.surname"
                            header="Surname"
                            body={(e) => {
                              if (
                                e.bookedUserDetails &&
                                e.bookedUserDetails.length
                              ) {
                                return e.bookedUserDetails[0].surname;
                              }
                            }}
                            sortable={false}
                            filter={false}
                            style={{ overflow: "auto" }}
                          />
                          <pr.Column
                            field="paid"
                            header="Paid?"
                            body={(e) => {
                              if (e.paid) {
                                return "Yes";
                              } else {
                                return "No";
                              }
                            }}
                            sortable={false}
                            filter={false}
                            style={{ overflow: "auto" }}
                          />
                          <pr.Column
                            field="paymentMethod"
                            header="Payment Method"
                            sortable={true}
                            filter={true}
                            style={{ overflow: "auto" }}
                          />
                        </pr.DataTable>
                      </div>
                      <div className="ui-g-12">
                        <pr.Button
                          label="View Classes"
                          onClick={() => {
                            this.setState({ viewingClasses: true });
                          }}
                          style={{ float: "right" }}
                        />
                        <pr.Button
                          label="Edit Set"
                          onClick={() => {
                            this.setState({
                              setSelected: false,
                              setEdited: true,
                              editedSet: this.state.selectedSet,
                              editedSetDateFrom:
                                this.state.selectedSetDateFrom2,
                              editedSetDateTo: this.state.selectedSetDateTo2,
                              editedSetMaxNumberOfParticipants:
                                this.state.selectedSetMaxNumberOfParticipants,
                              editedSetNumberOfParticipants:
                                this.state.selectedSetNumberOfParticipants,
                              editedSetInstructors:
                                this.state.selectedSetInstructors,
                              editedSetInstructorNames:
                                this.state.selectedSetInstructorNames,
                              editedSetBookList: this.state.selectedSetBookList,
                              editedSetBookedUserDetails:
                                this.state.selectedSetBookedUserDetails,
                            });
                          }}
                          style={{ float: "right" }}
                        />
                        <pr.Button
                          label="Create Set"
                          onClick={() => {
                            localStorage.setItem("reCreate", true);
                            localStorage.setItem(
                              "reCreateServiceId",
                              this.state.selectedServiceId
                            );
                            window.location = "#/createsets";
                          }}
                          style={{ float: "right" }}
                        />
                      </div>
                    </div>
                  )}

                  {!this.state.setEdited ? (
                    <label />
                  ) : (
                    <div>
                      <div className="ui-g-12">
                        <b>Instructor(s): </b>
                        <br />
                        <br />
                        <pr.PickList
                          source={this.state.pickListAvailable || []}
                          target={this.state.pickListSelected || []}
                          sourceHeader="Available"
                          targetHeader="Selected"
                          responsive={true}
                          itemTemplate={(e) => (
                            <span>{e.firstName + " " + e.surname}</span>
                          )}
                          onChange={(e) => {
                            this.setState({
                              pickListAvailable: e.source,
                              pickListSelected: e.target,
                            });
                          }}
                        />
                      </div>
                      <div className="ui-g-12">
                        <label>
                          Slots{" "}
                          {!this.state.selectedSetBookedUserDetails
                            ? this.state.selectedSetMaxNumberOfParticipants || 0
                            : this.state.selectedSetMaxNumberOfParticipants -
                              this.state.selectedSetBookedUserDetails
                                .length}{" "}
                          of{" "}
                          {!this.state.selectedSetMaxNumberOfParticipants
                            ? 0
                            : this.state
                                .selectedSetMaxNumberOfParticipants}{" "}
                          remaining
                        </label>
                      </div>

                      <div className="ui-g-12">
                        <div className="ui-g-4">
                          <label>Add another client to set</label>
                          <br />
                          <pr.Dropdown
                            value={this.state.selectedClient}
                            options={this.state.clientOptions}
                            onChange={(e) => {
                              this.setState({
                                selectedClient: e.value,
                              });
                            }}
                          />
                        </div>
                        <div className="ui-g-4">
                          <label>Paid</label>
                          <br />
                          <pr.Dropdown
                            value={this.state.selectedPaid}
                            options={[
                              { label: "Yes", value: true },
                              { label: "No", value: false },
                            ]}
                            onChange={(e) => {
                              this.setState({
                                selectedPaid: e.value,
                              });
                            }}
                          />
                        </div>
                        <div className="ui-g-4">
                          <label>Payment Method</label>
                          <br />
                          <pr.Dropdown
                            value={this.state.selectedPaymentMethod}
                            options={[
                              { label: "App", value: "App" },
                              { label: "Cash", value: "Cash" },
                              { label: "Card", value: "Card" },
                            ]}
                            onChange={(e) => {
                              this.setState({
                                selectedPaymentMethod: e.value,
                              });
                            }}
                          />
                        </div>
                      </div>

                      <div className="ui-g-12">
                        <b>List of Clients in Set</b>
                        <br />
                        <pr.DataTable
                          value={
                            this.state.selectedSetCompleteBookedListUserDetails
                          }
                          selectionMode="single"
                          onSelectionChange={() => {}}
                          header="Clients"
                          autoLayout={true}
                          paginator={true}
                          alwaysShowPaginator={true}
                          rows="10"
                          emptyMessage="No clients in set"
                        >
                          <pr.Column
                            field="bookedUserDetails.firstName"
                            header="First Name"
                            body={(e) => {
                              if (
                                e.bookedUserDetails &&
                                e.bookedUserDetails.length
                              ) {
                                return e.bookedUserDetails[0].firstName;
                              }
                            }}
                            sortable={false}
                            filter={false}
                            style={{ overflow: "auto" }}
                          />
                          <pr.Column
                            field="bookedUserDetails.surname"
                            header="Surname"
                            body={(e) => {
                              if (
                                e.bookedUserDetails &&
                                e.bookedUserDetails.length
                              ) {
                                return e.bookedUserDetails[0].surname;
                              }
                            }}
                            sortable={false}
                            filter={false}
                            style={{ overflow: "auto" }}
                          />
                          <pr.Column
                            field="paid"
                            header="Paid?"
                            body={(e) => {
                              if (e.paid) {
                                return "Yes";
                              } else {
                                return "No";
                              }
                            }}
                            sortable={false}
                            filter={false}
                            style={{ overflow: "auto" }}
                          />
                          <pr.Column
                            field="paymentMethod"
                            header="Payment Method"
                            sortable={true}
                            filter={true}
                            style={{ overflow: "auto" }}
                          />
                        </pr.DataTable>
                      </div>
                      <div className="ui-g-12">
                        <pr.Button
                          label="Update Instructors"
                          onClick={() => {
                            this.updateSet();
                          }}
                          style={{ float: "right" }}
                        />
                        <pr.Button
                          label="Add Client"
                          onClick={() => {
                            this.updateClients();
                          }}
                          style={{ float: "right" }}
                        />
                        <pr.Button
                          label="Cancel"
                          onClick={() => {
                            this.setState({
                              setEdited: false,
                              setSelected: true,
                            });
                          }}
                          style={{ float: "right" }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {!this.state.viewingClasses ? (
            <label />
          ) : (
            <div>
              {this.booksToCard()}

              <div className="ui-g-12">
                <pr.Button
                  label="Add New Class"
                  onClick={() => {
                    localStorage.setItem(
                      "selectedSetId",
                      this.state.selectedSetId
                    );
                    localStorage.setItem(
                      "selectedSetServiceId",
                      this.state.selectedServiceId
                    );
                    window.location = "#/createclasses";
                  }}
                  style={{ float: "right" }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Classes/Classes.js